import _ from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import GoogleMapPlugin from './google-maps-plugin/main'
import store from './store/index'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import langs from './langs/langs'

const NIKON = 5;
const JAI_KUDO = 4;
const VARILUX = 3;
const CNW = 2;
const JZO = 1;

const DEV = process.env.VUE_APP_DEV === 'true';

const SITE_ASSET_DIR = {
    5: 'nikon',
    4: 'jai-kudo',
    3: 'varilux',
    2: 'cnw',
    1: 'jzo'
};

const API_KEY = {
    // dev: 'AIzaSyByosZnxZeTZgNKl-yeWM4KFeEyN3vX0Po',
    dev: '',
    5: 'AIzaSyCAIitSUfx5ySj0b5O7eB24Nkmkp2geJJQ', // JZO Nikon
    4: 'AIzaSyB3TYh9UVGiRAFVn2G0jckaa9u_k22FFA8', // Jai Kudo
    3: 'AIzaSyCyE5w4-XuuVs_aA7VbBba_7VhZqDvPXoc', // VARILUX
    2: 'AIzaSyD6DC8-plcN9N4KEUKJopI3e9NPGY-_sKQ', // CNW
    1: 'AIzaSyCAIitSUfx5ySj0b5O7eB24Nkmkp2geJJQ' // JZO
}

// Select site variant
let SITE_VARIANT = VARILUX;
switch(process.env.VUE_APP_VARIANT) {
    case 'varilux':
        SITE_VARIANT = VARILUX;
        break;
    case 'jzo':
        SITE_VARIANT = JZO;
        break;
    case 'cnw':
        SITE_VARIANT = CNW;
        break;
    case 'jai-kudo':
        SITE_VARIANT = JAI_KUDO;
        break;
    case 'nikon':
        SITE_VARIANT = NIKON;
        break;
}


import(`./styles/app-${SITE_ASSET_DIR[SITE_VARIANT]}.scss`)

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.get['Content-Type'] = 'application/json';

Vue.use(GoogleMapPlugin, {
    // key: 'AIzaSyByosZnxZeTZgNKl-yeWM4KFeEyN3vX0Po',
    key: API_KEY[DEV ? 'dev' : SITE_VARIANT],
    libraries: 'places,geometry'
})

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: process.env.VUE_APP_LANG.toLowerCase(),
    fallbackLocale: 'pl',
    messages: langs
})

Vue.config.productionTip = false
Vue.prototype.$appLang = process.env.VUE_APP_LANG.toUpperCase();
Vue.prototype.$siteVariant = SITE_VARIANT;
Vue.prototype.$siteVariantName = process.env.VUE_APP_VARIANT;
Vue.prototype.$siteAssetDir = 'assets/' + SITE_ASSET_DIR[SITE_VARIANT];
Vue.prototype.$siteVariantImages = {
    3: {
        pinActive: 'https://essilorlocator.pl/essilor/assets/pinActive.svg',
        pinNormal: 'https://essilorlocator.pl/essilor/assets/pinNormal.svg',
        cluster: 'https://essilorlocator.pl/essilor/assets/cluster.svg',
        map: 'https://essilorlocator.pl/essilor/assets/ikonka-polska.png',
        plus: 'https://essilorlocator.pl/essilor/assets/iconPlus2.svg',
        minus: 'https://essilorlocator.pl/essilor/assets/-.svg',
        loupe: 'https://essilorlocator.pl/essilor/assets/loupe.svg',
    }
}

if(!parent.dataLayer) parent.dataLayer = []

new Vue({
    i18n,
    store,
    render: h => h(App),
    created() {
        let siteId = 'varilux'
        siteId = SITE_ASSET_DIR[SITE_VARIANT];
        if(this.$appLang !== 'PL') {
            siteId += '_' + this.$appLang.toLowerCase();
        }
        this.$store.commit('setSiteId', siteId)
        this.$store.commit('setLang', this.$appLang)
        this.$store.dispatch('getInstitutions')
    }
}).$mount('#app')
